import React from "react";


export const Customers = () => {
    return (
        <h2>CUSTOMERS</h2>
    )
}